import { LockPlugin, RangePlugin, easepick } from '@easepick/bundle'
import BookingEngineEnum from '../enumerators/booking-engine.enum'

export default class BookingEngineComponent {
    constructor() {
        BookingEngineComponent.initDatePicker()
        BookingEngineComponent.initDatePickerMobile()
        BookingEngineComponent.onInputClick()
        BookingEngineComponent.mobileDialogOpen()
        BookingEngineComponent.mobileDialogClose()

        if (
            $(BookingEngineEnum.BODY).hasClass('has-engine-booking-banner') &&
            !$(BookingEngineEnum.BODY).hasClass('home')
        ) {
            BookingEngineComponent.urlBuilder(BookingEngineEnum.ENGINE_BOOKING_FORM)
        }
    }

    static initDatePicker() {
        if ($('#engine-booking-start-date').length > 0) {
            new easepick.create({
                element: document.getElementById('engine-booking-start-date'),
                css: [
                    'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
                    IRISCollectionCustomer.styleCustomerEasepick,
                ],
                zIndex: 99,
                lang: 'fr-FR',
                format: 'DD/MM/YYYY',
                grid: 1,
                calendars: 1,
                plugins: [RangePlugin, LockPlugin],
                RangePlugin: {
                    elementEnd: document.getElementById('engine-booking-end-date'),
                    tooltip: false,
                },
                LockPlugin: {
                    minDate: new Date(),
                },
                setup(picker) {
                    picker.on('select', () => {
                        BookingEngineComponent.urlBuilder(BookingEngineEnum.ENGINE_BOOKING_FORM)
                    })
                },
            })
        }
    }

    static initDatePickerMobile() {
        if ($('#engine-booking-start-date-mobile').length > 0) {
            new easepick.create({
                element: document.getElementById('engine-booking-start-date-mobile'),
                css: [
                    'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
                    IRISCollectionCustomer.styleCustomerEasepick,
                ],
                zIndex: 99,
                lang: 'fr-FR',
                format: 'DD/MM/YYYY',
                grid: 1,
                calendars: 1,
                plugins: [RangePlugin, LockPlugin],
                RangePlugin: {
                    elementEnd: document.getElementById('engine-booking-end-date-mobile'),
                    tooltip: false,
                },
                LockPlugin: {
                    minDate: new Date(),
                },
                setup(picker) {
                    picker.on('select', () => {
                        BookingEngineComponent.urlBuilder(
                            BookingEngineEnum.ENGINE_BOOKING_FORM_MOBILE,
                        )
                    })
                },
            })
        }
    }

    static onInputClick() {
        const startDate = $(BookingEngineEnum.ENGINE_BOOKING_FORM).find('[data-input="start-date"]')
        const endDate = $(BookingEngineEnum.ENGINE_BOOKING_FORM).find('[data-input="end-date"]')

        $(BookingEngineEnum.ENGINE_BOOKING_INPUT).on('change', (event) => {
            BookingEngineComponent.urlBuilder($(event.target).parents('form'))
        })

        if (window.matchMedia('(min-width: 1001px)').matches) {
            $(startDate).on('click', () => {
                $('html, body').animate(
                    {
                        scrollTop: $('#engine-booking').offset().top - 150,
                    },
                    200,
                )
            })

            $(endDate).on('click', () => {
                $('html, body').animate(
                    {
                        scrollTop: $('#engine-booking').offset().top - 150,
                    },
                    200,
                )
            })
        }
    }

    static urlBuilder(form) {
        const urlBase = $(form).find('[data-input="type"]').val()
        let startDate = $(form).find('[data-input="start-date"]').val()
        let endDate = $(form).find('[data-input="end-date"]').val()
        const adults = $(form).find('[data-input="adults"]').val()
        const children = $(form).find('[data-input="children"]').val()

        if (~startDate.indexOf('/')) {
            const splitDate = startDate.split('/')
            startDate = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`
        }

        if (~endDate.indexOf('/')) {
            const splitDate = endDate.split('/')
            endDate = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`
        }

        $(form).attr(
            'action',
            `${urlBase}recherche/marketplace/${startDate}/${endDate}/${adults}/${children}/?startdate=${startDate}&enddate=${endDate}&adults=${adults}&children=${children}#liste`,
        )
    }

    static mobileDialogOpen() {
        $(BookingEngineEnum.ENGINE_BOOKING_OPEN).on('click', () => {
            $(BookingEngineEnum.BODY).addClass('engine-booking-open')
        })
    }

    static mobileDialogClose() {
        $(BookingEngineEnum.ENGINE_BOOKING_CLOSE).on('click', () => {
            $(BookingEngineEnum.BODY).removeClass('engine-booking-open')
        })

        //On escape key
        $(document).on('keyup', (e) => {
            if (e.keyCode === 27) {
                $(BookingEngineEnum.BODY).removeClass('engine-booking-open')
            }
        })
    }
}
